<template>
  <div class="login-wrap">
    <div class="top">自动登录中...</div>
    <van-dialog
      v-model="show"
      title="请选择下单公司"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="modalCenter">
        <van-button
          type="info"
          plain
          size="large"
          v-for="(item, index) in companyList"
          :key="index"
          @click="checkCompany(item)"
          class="item"
        >
          {{ item.companyName }}
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { employeeCompany, switchCompany } from '@/common/api.js';
import { cookieSet } from '@/common/cookie';
import { mapMutations } from 'vuex';

export default {
  name: 'AccidentRescueAutoLogin',
  data() {
    return {
      token: '',
      show: false,
      companyList: []
    };
  },
  computed: {
    isDisabled() {
      if (this.code && this.code.length > 0 && this.phone && this.phone.length > 0) {
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.init();
  },
  activated() {
    this.init();
  },

  methods: {
    ...mapMutations([
      'setAccidentRescueInfo'
    ]),
    init() {
      console.log('this.$route.params: ', this.$route.params);
      if (this.$route.params.token) {
        // 清理创建订单的缓存
        this.setAccidentRescueInfo(null);
        this.token = decodeURIComponent(this.$route.params.token);
        cookieSet('token', this.token);
        this.getEmployeeCompany();
      } else {
        Toast('token丢失');
      }
    },
    async getEmployeeCompany() {
      try {
        const res = await employeeCompany({ isWxDps: '1' });
        if (res) {
          this.companyList = res;
          this.show = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkCompany(data) {
      console.log(data.id, 'data.id');
      cookieSet('channelCompanyCode', data.id);
      try {
        await switchCompany({ companyId: data.id });
        this.$router.replace({
          path: '/accidentRescue/list',
          query: {
            phone: this.phone
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  },

  destroyed() {
    try {
      if (this.timer) {
        clearInterval(this.timer);
      }
    } catch (error) {}
  }
};
</script>

<style lang="scss">
.login-wrap {
  .van-cell {
    padding-left: 0px;
  }
}
</style>

<style lang="scss" scoped>
.login-wrap {
  width: 7.5rem;
  height: 100wh;

  background-color: white;
}

.top {
  margin-top: 0.96rem;
  margin-left: 0.6rem;

  text-align: center;

  color: #383838;

  font-size: 0.48rem;
}

.content {
  display: flex;
  flex-direction: column;

  width: 6.3rem;
  margin-top: 1.12rem;
  margin-left: 0.6rem;

  font-size: 0.32rem;
}

.fieldBox {
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;

  color: #383838;
  border-bottom: 1px solid #e6e6e6;

  font-size: 0.32rem;

  .delete {
    width: 0.4rem;
    height: 0.4rem;
  }

  .field-wrapper {
    flex: 1;
  }

  .code {
    color: #3399ff;

    &.disable {
      color: #b3d9ff;
    }
  }
}

.title {
  margin-bottom: 0.32rem;

  color: #646464;

  font-size: 0.3rem;
}

.submit {
  width: 6.3rem;
  height: 0.96rem;
  margin-top: 1.45rem;

  font-size: 0.32rem;
}
.modalCenter{
  overflow: auto;

  box-sizing: border-box;
  max-height: 70vh;
  margin: 0.3rem 0;
  padding: 0 0.2rem;
  .item{
    margin-top: 0.3rem;

    text-align: center;
  }
}
</style>
